import { html } from 'lit';
const Embed =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' d="M3.25 6A2.75 2.75 0 0 1 6 3.25h2.5a.75.75 0 0 1 0 1.5H6c-.69 0-1.25.56-1.25 1.25v2.5a.75.75 0 0 1-1.5 0zM14.75 4a.75.75 0 0 1 .75-.75H18A2.75 2.75 0 0 1 20.75 6v2.5a.75.75 0 0 1-1.5 0V6c0-.69-.56-1.25-1.25-1.25h-2.5a.75.75 0 0 1-.75-.75M11.884 12.116a1.25 1.25 0 0 0-1.768 0l-.55.55a.75.75 0 0 1-1.06-1.06l.55-.55a2.75 2.75 0 1 1 3.889 3.889l-2 2a2.75 2.75 0 0 1-3.89 0 .75.75 0 1 1 1.061-1.061 1.25 1.25 0 0 0 1.768 0l2-2a1.25 1.25 0 0 0 0-1.768"/><path fill='currentColor' d="M8.884 15.116a1.25 1.25 0 0 0-1.768 0l-2 2a1.25 1.25 0 0 0 1.768 1.768l.55-.55a.75.75 0 1 1 1.061 1.06l-.55.55a2.75 2.75 0 1 1-3.89-3.889l2-2a2.75 2.75 0 0 1 3.89 0 .75.75 0 0 1-1.061 1.061M20 14.75a.75.75 0 0 1 .75.75V18A2.75 2.75 0 0 1 18 20.75h-3a.75.75 0 0 1 0-1.5h3c.69 0 1.25-.56 1.25-1.25v-2.5a.75.75 0 0 1 .75-.75"/>
  </svg>
`;
export default Embed;
